import React, { useState } from 'react';
import { Link } from 'gatsby';
import './Navbar.scss';
import Accordion from '../Accordion/Accordion';
import '../Accordion/style.scss';
import { StaticImage } from "gatsby-plugin-image"
import Cta from '../../../atoms/CTA-Contrast/index';
import mobileMenu from '../../../../resources/images/mobileMenu.svg';
import cancelIcon from '../../../../resources/images/cancelIcon.svg';
import globalText from '../../../../helpers/globalText';

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);

  const handleOverlayKeyPress = (event) => {
    if (event.key === 'Enter') {
      setSidebar(!sidebar);
    }
  };

  return (
    <>
      <div className='navbar'>
        <Link to='#' className='menu-bars' onClick={() => setSidebar(!sidebar)} >
          <img src={mobileMenu} alt="Mobile menu" width="27" />
        </Link>
      </div>

      <div 
        className={sidebar ? 'overlay' : 'hide-overlay'} 
        onClick={() => setSidebar(!sidebar)} 
        onKeyDown={handleOverlayKeyPress}
        tabIndex="0"
        role="button" 
        aria-label="Close Navigation"
      />

      <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>

        <div className='nav-menu-items' >
          <div className="logoContainer">
            <a href="/">
              <StaticImage src="../../../../resources/images/logo-wordmark-black.png" alt="Motivosity Logo" style={{ width: '148px' }} placeholder="none" />
            </a>
            <button onClick={() => setSidebar(!sidebar)} style={{background: 'none', border: 'none'}}>
              <img src={cancelIcon} alt="Cancel icon" width="20" style={{ float: 'right', cursor: 'pointer' }} />
            </button>
          </div>
          <Accordion />

          <div className="mobileButtonContainer">
            <a href="https://app.motivosity.com/" className="mobile-login-button">Login</a>
            <a href='/demo' className="talk-to-sales" id="abTestSalesCta">Talk to Sales</a>
            <Cta ctaHref="/demo/" ctaText={globalText.watchADemo} />
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
